(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref400"];
var parcelRegister = parcelRequire.register;
parcelRegister("51wCY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a865ae50330f2c1$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");

var $fp3uY = parcelRequire("fp3uY");

var $3a865ae50330f2c1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function FeaturedContent(param) {
        var el = param.el, isLargeQuery = param.isLargeQuery;
        (0, $J7ygF._)(this, FeaturedContent);
        this.el = el;
        this.isLargeQuery = isLargeQuery;
        this.carouselEl = this.el.querySelector(".swiper");
        this.init();
    }
    (0, $hvJJn._)(FeaturedContent, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                if (this.carouselEl) {
                    this.carousel = new (0, $fp3uY.default)(this.carouselEl, {
                        loop: true,
                        slidesPerView: 1,
                        spaceBetween: 0,
                        breakpoints: {
                            1024: {
                                slidesPerView: 2
                            }
                        }
                    });
                    this.prev = this.el.querySelector(".prev");
                    this.next = this.el.querySelector(".next");
                    if (this.prev) this.prev.addEventListener("click", function() {
                        _this.carousel.slidePrev();
                    });
                    if (this.next) this.next.addEventListener("click", function() {
                        _this.carousel.slideNext();
                    });
                }
            }
        }
    ]);
    return FeaturedContent;
}();

});
parcelRegister("J7ygF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $087a0fb22a93b2d1$export$71511d61b312f219; });
function $087a0fb22a93b2d1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hvJJn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbf8ce221d4c5514$export$71511d61b312f219; });
function $cbf8ce221d4c5514$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cbf8ce221d4c5514$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});


parcelRegister("5vuqB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $40277363b68668b9$export$71511d61b312f219; });
function $40277363b68668b9$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("ltnlO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fa1e6b5e4cf4e6cf$export$71511d61b312f219; });

var $5vuqB = parcelRequire("5vuqB");
function $fa1e6b5e4cf4e6cf$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5vuqB._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("1WOPg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $16b2a2272a36e4b4$export$71511d61b312f219; });
function $16b2a2272a36e4b4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $16b2a2272a36e4b4$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $16b2a2272a36e4b4$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("5ZV7E", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $45def593611ffc53$export$71511d61b312f219; });

var $dakGr = parcelRequire("dakGr");

var $3iELS = parcelRequire("3iELS");

var $lbIZx = parcelRequire("lbIZx");

var $6HNFp = parcelRequire("6HNFp");
function $45def593611ffc53$export$71511d61b312f219(arr, i) {
    return (0, $dakGr._)(arr) || (0, $3iELS._)(arr, i) || (0, $6HNFp._)(arr, i) || (0, $lbIZx._)();
}

});
parcelRegister("dakGr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $995c40d652b0553f$export$71511d61b312f219; });
function $995c40d652b0553f$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("3iELS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2672addbd595e189$export$71511d61b312f219; });
function $2672addbd595e189$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("lbIZx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f6cd8669e12714d8$export$71511d61b312f219; });
function $f6cd8669e12714d8$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("6HNFp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4e1d490ad7b9bee1$export$71511d61b312f219; });

var $84Wdk = parcelRequire("84Wdk");
function $4e1d490ad7b9bee1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $84Wdk._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $84Wdk._)(o, minLen);
}

});
parcelRegister("84Wdk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5e1bda8aa9cfef6d$export$71511d61b312f219; });
function $5e1bda8aa9cfef6d$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



})();
//# sourceMappingURL=FeaturedContent.da7b8416.js.map
